import { createSlice } from "@reduxjs/toolkit";

const airLinesDetails = [];

const backupData = [];

const getAirLinesByRoutesIataSlice = createSlice({
  name: "getAirlinesByRoutesIata",
  initialState: {
    airLinesDetails,
    backupData,
  },
  reducers: {
    reSetAirLinesDetails(state, action){
      state.airLinesDetails = []
      state.backupData = []
    },
    setAirLinesDetails(state, action) {
      state.airLinesDetails = action.payload;
    },
    setBackupData(state, action) {
      state.backupData = action.payload;
    },
  },
});

export const { setAirLinesDetails, setBackupData,reSetAirLinesDetails } =
  getAirLinesByRoutesIataSlice.actions;

export default getAirLinesByRoutesIataSlice.reducer;
